let activeTeam = null
let activeDays = []

const applyFilters = () => {
  document.querySelectorAll('.seatingChartPackage').forEach(pkg => {
    const categories = (pkg.getAttribute('data-category-names') || '')
      .split(',')
      .map(c => c.trim())
      .filter(Boolean)

    const teamMatch = !activeTeam || categories.includes(activeTeam)
    const daysMatch = activeDays.length === 0 || activeDays.some(d => categories.includes(d))

    pkg.classList.toggle('pkg-hidden', !(teamMatch && daysMatch))
  })
}

document.addEventListener('turbo:load', () => {
  activeTeam = null
  activeDays = []

  const teamParam = new URLSearchParams(window.location.search).get('team')
  const paramBtn = teamParam
    ? document.querySelector(`.nrl-sc-team[data-filter="${teamParam}"]`)
    : null

  if (paramBtn) {
    activeTeam = teamParam
    document.querySelectorAll('.nrl-sc-team').forEach(b => b.classList.remove('active'))
    paramBtn.classList.add('active')
    applyFilters()
  } else {
    activeTeam = null
    const allTeamsBtn = document.querySelector('.nrl-sc-team[data-filter="all"]')
    if (allTeamsBtn) allTeamsBtn.classList.add('active')
  }

  document.querySelectorAll('.nrl-sc-team').forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.getAttribute('data-filter')

      if (btn.classList.contains('active')) return

      activeTeam = filter === 'all' ? null : filter

      document.querySelectorAll('.nrl-sc-team').forEach(b => b.classList.remove('active'))
      btn.classList.add('active')

      applyFilters()
    })
  })

  document.querySelectorAll('.nrl-sc-days-option input[type=checkbox]').forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const filter = checkbox.closest('.nrl-sc-days-option').getAttribute('data-filter')

      if (checkbox.checked) {
        if (!activeDays.includes(filter)) activeDays.push(filter)
      } else {
        activeDays = activeDays.filter(d => d !== filter)
      }

      applyFilters()
    })
  })
})
